import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import IntroAdvantageSection from './components/IntroAdvantageSection';
import IntroCoverageSection from './components/IntroCoverageSection';
import IntroCtaSection from './components/IntroCtaSection';
import IntroFaqSection from './components/IntroFaqSection';
import IntroHeroSection from './components/IntroHeroSection';
import IntroPortalSection from './components/IntroPortalSection';
import IntroResourcesSection from './components/IntroResourcesSection';
import { getDefaultPortalIntroInfo } from './config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './config';
export * from './types';
export * from './utils';
export var PortalIntroView = function PortalIntroView(props) {
  var info = props.info,
      countryCode = props.countryCode,
      onLogin = props.onLogin,
      onGetAccess = props.onGetAccess;

  var _ref = info || {},
      heroHidden = _ref.heroHidden,
      coverageHidden = _ref.coverageHidden,
      portalHidden = _ref.portalHidden,
      advantageHidden = _ref.advantageHidden,
      ctaHidden = _ref.ctaHidden,
      resourcesHidden = _ref.resourcesHidden,
      faqHidden = _ref.faqHidden; // Design-default copy follows the displayed country version's language; server-provided custom content always wins


  var defaultInfo = useMemo(function () {
    return getDefaultPortalIntroInfo(countryCode);
  }, [countryCode]);
  var formMethods = useForm({
    defaultValues: _objectSpread(_objectSpread({}, defaultInfo), info)
  });
  var reset = formMethods.reset;
  /**
   * effects
   */

  useEffect(function () {
    reset(_objectSpread(_objectSpread({}, defaultInfo), info));
  }, [info, defaultInfo, reset]);
  /**
   * methods
   */

  var loginAction = function loginAction() {
    onLogin === null || onLogin === void 0 ? void 0 : onLogin();
  };

  var getAccessAction = function getAccessAction() {
    onGetAccess === null || onGetAccess === void 0 ? void 0 : onGetAccess();
  };

  return /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, formMethods), {}, {
    children: /*#__PURE__*/_jsx(Box, {
      className: "flex w-full flex-col bg-[linear-gradient(180deg,#EBF3F9_0%,#EBF3F9_10%,#FFFFFF_28%,#FFFFFF_50%,#EBF3F9_62%,#EBF3F9_100%)]",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "mx-auto flex w-full max-w-[1280px] flex-col px-4 md:px-6",
        children: [!heroHidden && /*#__PURE__*/_jsx(IntroHeroSection, {
          onLogin: loginAction,
          onGetAccess: getAccessAction
        }), !coverageHidden && /*#__PURE__*/_jsx(IntroCoverageSection, {}), !portalHidden && /*#__PURE__*/_jsx(IntroPortalSection, {}), !advantageHidden && /*#__PURE__*/_jsx(IntroAdvantageSection, {}), !ctaHidden && /*#__PURE__*/_jsx(IntroCtaSection, {
          onLogin: loginAction,
          onGetAccess: getAccessAction
        }), !resourcesHidden && /*#__PURE__*/_jsx(IntroResourcesSection, {}), !faqHidden && /*#__PURE__*/_jsx(IntroFaqSection, {})]
      })
    })
  }));
};
export default PortalIntroView;